var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "27px",
    viewBox: "0 0 36 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Single-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Single-Page",
    transform: "translate(-48.000000, -2339.000000)",
    fill: "#00A7E7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-2",
    transform: "translate(12.000000, 1914.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkbox",
    transform: "translate(24.000000, 408.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.65925,42.46175 L12.65925,30.46175 C11.78025,29.58275 11.78025,28.15775 12.65925,27.28025 L14.78025,25.15925 C15.65925,24.28025 17.08425,24.28025 17.96175,25.15925 L26.25075,33.44675 L42.03825,17.65925 C42.91725,16.78025 44.34225,16.78025 45.21975,17.65925 L47.34075,19.78025 C48.21975,20.65925 48.21975,22.08425 47.34075,22.96175 L27.84075,42.46175 C26.96325,43.33925 25.53825,43.33925 24.65925,42.46175 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fb54f16e4fea9a1d18d5f7dc41c0ca1c.svg";
export { ForwardRef as ReactComponent };